<template>
  <div class="box box-6" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 6)">
    <img class="img-6" :src="img6" alt="" />
    <img class="add-icon" :src="addIcon" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_12') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_9') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    img6() {
      return require('../../assets/images/keypal-two/introduce-6.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-6 {
  width: 384px;
  height: 286px;
  border-radius: 32px;

  .img-6 {
    width: 162px;
    height: 149px;
    position: absolute;
    top: 32px;
    right: 30px;
  }
}

@media screen and (max-width: 1200px) {
  .box-6 {
    width: calc(384 / 1300 * 100vw);
    height: calc(286 / 1300 * 100vw);
    .img-6 {
      width: calc(162 / 1300 * 100vw);
      height: calc(149 / 1300 * 100vw);
    }
  }
}

@media screen and (max-width: 767px) {
  .box-6 {
    width: 276px;
    height: auto;
    .img-6 {
      width: 176px;
      height: 162px;
      position: absolute;
      left: 50%;
      top: 150px;
      transform: translateX(-50%);
    }
  }
}
</style>
